import { render, staticRenderFns } from "./ScreenObsequiosFacturador.vue?vue&type=template&id=16ff99df&scoped=true"
import script from "./ScreenObsequiosFacturador.vue?vue&type=script&lang=js"
export * from "./ScreenObsequiosFacturador.vue?vue&type=script&lang=js"
import style0 from "./ScreenObsequiosFacturador.vue?vue&type=style&index=0&id=16ff99df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff99df",
  null
  
)

export default component.exports